<script>
  import { _ } from 'svelte-i18n'
  import { getFeatureName } from '../../../modules/helpers'
  import Insert from '../../../elements/Insert.svelte'
  import OpenBuyModalButton from '../../../components/OpenBuyModalButton.svelte'
  
  export let feature
</script>

<Insert insert_position="between_previews">
  <span slot="toptitle">
    {@html $_('inserts.' + feature + '.topTitle') }
  </span>
  <span slot="title">
    {@html $_('inserts.shared.inbetweenTitle', {values: {feature_name: getFeatureName(feature).toLowerCase()}}) }
  </span>
  <span slot="text">
    { $_('inserts.shared.partOfProTimeSaving', {values: {feature_name: getFeatureName(feature)}}) }
    <small>
      { $_('inserts.shared.thousands')}
    </small>
  </span>
  <span slot="button">
    <OpenBuyModalButton {feature}>{ $_('inserts.buttons.seePrice') }</OpenBuyModalButton> 
  </span>
</Insert> 